import React from "react";
import { Row, Col, FormGroup, InputGroup, InputGroupAddon, Button } from "shards-react";
export default (props) => {
  let input;

  const handleKeyPress = (event) => {
    if (event.which === 13 || event.keyCode === 13)
      props.onSearch(input.value);
  };

  const handleClick = () => {
    props.onSearch(input.value);
  };

  const handleAdd = () =>{
    props.handleEdit()
  }

  const handleImport = () =>{
    props.handleImport()
  }

  return (
     <Row className="pt-4 pb-2">
       <Col className="col-md-9">
         <Row>
           <FormGroup className="col-12">
            <Button onClick={ handleAdd } size="sm" ><i className="material-icons">add</i> Agregar</Button>
            <Button className="ml-1" onClick={ handleImport } size="sm" ><i className="material-icons">input</i> Importar</Button>
           </FormGroup>
         </Row>
       </Col>
       <Col className="col-md-3">
         <InputGroup className="mb-3" >
           <input className="form-control" ref={ n => input = n } onKeyPress={(e)=>handleKeyPress(e)} type="text"  placeholder="Buscar"   />
           <InputGroupAddon type="append">
             <Button onClick={ handleClick }  ><i className="material-icons">search</i></Button>
           </InputGroupAddon>
         </InputGroup>
         </Col>
     </Row>


  );
};
